<template>
  <div class="screen-booking">
    <div class="popup-aside-plain">
      <div class="popup-takeResa">
        <div style="text-align:center">{{ getAllInfos.restoName }}</div>
        <div style="font-weight:100; font-size:14px">
          <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
          <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
        </div>
      </div>
      <div class="success-container" v-loading="loading">
        <el-row :class="'black-inputs'">
          <el-col :span="18" :offset="3">
            Le moyen de paiement n'as pas fonctionné<br>
            <br>
            La réservation n'as pas été prise en compte<br>
            <br>
            Vous allez être redirigé automatiquement vers l'application
            <br>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// ------------------------------------------------------------------------------------ Imports
import { mapActions, mapGetters } from 'vuex';
import 'whatwg-fetch';

export default {
  name: 'CancelApp',
  // -------------------------------------------------------------------------------- Datas
  data() {
    return {
      link: '#'
    }
  },
  computed: {
    // ------------------------------------------------------------------------------ Getters
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos'
    })
  },
  methods: {
    // ----------------------------------------------------------------------------- Methods and Actions
    ...mapActions({
      findRealUserRole: 'newUsers/findRealUserRole'
    })
  },
  // ------------------------------------------------------------------------------------ Created
  created: function () {
    this.link = '/restaurant'
    // redirection auto
    setTimeout(() => {
      this.findRealUserRole().then((u) => {
        if (u === 'Permanence') {
          // for permanence
          this.$router.push({ name: 'PRedirect', params: { id: this.$router.currentRoute.params.id } })
          window.location.reload()
        } else {
          // for resto
          this.$router.push({ name: 'Restaurant' })
        }
      })
    }, 4000)
    // remove version
    if (this.$parent.$refs.version !== undefined) this.$parent.$refs.version.remove()
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";

a {
  color: var(--color_blue_azure);
}

.success {
  &-content {
    text-align: center;
    font-weight: 100;
    margin-top: 1rem;
  }

  &-container {
    padding-bottom: 1rem;
  }

  &-btns {
    margin-top: 2rem;
  }

  &-infos {
    margin-top: 1rem;
    font-weight: bold;
  }
}
</style>
